export function assert(condition, msg) {
  if (!condition) {
    throw new Error(`[sdk] ${msg}`)
  }
}

export function compare(v1, symbol, v2) {
  v1 = parse(v1)
  v2 = parse(v2)
  if (symbol.indexOf('=') !== -1 && v1 === v2) {
    return true
  }
  if (symbol.indexOf('>') !== -1 && v1 > v2) {
    return true
  }
  if (symbol.indexOf('<') !== -1 && v1 < v2) {
    return true
  }
  return false
}

function parse(version = '') {
  version = version.split('.')
  while (version.length < 4) {
    version.push('00')
  }

  let ret = []
  version.forEach((n) => {
    if (n && n.length >= 2) {
      ret.push(n.substr(0, 2))
    } else {
      if (n) {
        n = n * 1
        ret.push(n >= 10 ? n : '0' + n)
      } else {
        ret.push('00')
      }
    }
  })
  return parseInt(ret.join(''), 10)
}

export function noop() {
}

export function getContent(content, key, lang = 'zh=CN') {
  const defaultLang = 'zh-CN'
  if (content[lang]) {
    return content[lang][key]
  }
  return content[defaultLang][key]
}

export function isHttps() {
  return window.location.protocol === 'https:'
}

export function isLocalhost() {
  return window.location.hostname === 'localhost'
}
